import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Button, Row, Col, Nav } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import {
  FaTrash,
  FaSort,
  FaSortUp,
  FaSortDown,
  FaPlus,
  FaCopy,
  FaSearch,
  FaSitemap,
  FaChevronRight,
  FaLayerGroup,
  FaUsers,
  FaUserFriends,
  FaExchangeAlt,
} from 'react-icons/fa';
import Header from '~/Components/Header/Header';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { intToHexColor } from '~/Utils/Helpers';
import * as api from '~/Services/Service';
import ModalCopiarHierarquia from './ModalCopiarHierarquia';
import './styles.css';

const HierarquiaComercial = function() {
  // State
  const _s = function(val) {
    return useState(val);
  };

  // Aba ativa: 'consulta' ou 'gestao'
  const abaAtivaState = _s('gestao');
  const abaAtiva = abaAtivaState[0];
  const setAbaAtiva = abaAtivaState[1];

  // State da consulta (modo read-only por conta)
  const corretoresState = _s([]);
  const corretores = corretoresState[0];
  const setCorretores = corretoresState[1];
  const corretorSelecionadoState = _s(null);
  const corretorSelecionado = corretorSelecionadoState[0];
  const setCorretorSelecionado = corretorSelecionadoState[1];
  const consultaHierarquiaState = _s([]);
  const consultaHierarquia = consultaHierarquiaState[0];
  const setConsultaHierarquia = consultaHierarquiaState[1];
  const loadingConsultaState = _s(false);
  const loadingConsulta = loadingConsultaState[0];
  const setLoadingConsulta = loadingConsultaState[1];
  const ordConsultaState = _s({ campo: null, direcao: 'asc' });
  const ordConsulta = ordConsultaState[0];
  const setOrdConsulta = ordConsultaState[1];

  const gruposEmpresaState = _s([]);
  const gruposEmpresa = gruposEmpresaState[0];
  const setGruposEmpresa = gruposEmpresaState[1];
  const geSelecionadoState = _s(null);
  const geSelecionado = geSelecionadoState[0];
  const setGeSelecionado = geSelecionadoState[1];

  const tiposComissaoState = _s([]);
  const tiposComissao = tiposComissaoState[0];
  const setTiposComissao = tiposComissaoState[1];
  const tipoSelecionadoState = _s(null);
  const tipoSelecionado = tipoSelecionadoState[0];
  const setTipoSelecionado = tipoSelecionadoState[1];

  const contasTipoState = _s([]);
  const contasTipo = contasTipoState[0];
  const setContasTipo = contasTipoState[1];
  const contaSelecionadaState = _s(null);
  const contaSelecionada = contaSelecionadaState[0];
  const setContaSelecionada = contaSelecionadaState[1];

  const subordinadosState = _s([]);
  const subordinados = subordinadosState[0];
  const setSubordinados = subordinadosState[1];

  const contasDisponiveisState = _s([]);
  const contasDisponiveis = contasDisponiveisState[0];
  const setContasDisponiveis = contasDisponiveisState[1];
  const contasSubordinadosState = _s([]);
  const contasSubordinados = contasSubordinadosState[0];
  const setContasSubordinados = contasSubordinadosState[1];

  const selectContaTipoState = _s(null);
  const selectContaTipo = selectContaTipoState[0];
  const setSelectContaTipo = selectContaTipoState[1];
  const selectContaSubState = _s(null);
  const selectContaSub = selectContaSubState[0];
  const setSelectContaSub = selectContaSubState[1];

  const gesHierarquiaState = _s([]);
  const gesHierarquia = gesHierarquiaState[0];
  const setGesHierarquia = gesHierarquiaState[1];
  const geOrigemCopiaState = _s(null);
  const geOrigemCopia = geOrigemCopiaState[0];
  const setGeOrigemCopia = geOrigemCopiaState[1];

  const loadingState = _s({
    tipos: false,
    contas: false,
    subordinados: false,
    copia: false,
  });
  const loading = loadingState[0];
  const setLoading = loadingState[1];

  const mostrarModalCopiaState = _s(false);
  const mostrarModalCopia = mostrarModalCopiaState[0];
  const setMostrarModalCopia = mostrarModalCopiaState[1];

  const mostrarCopiarHierarquiaState = _s(false);
  const mostrarCopiarHierarquia = mostrarCopiarHierarquiaState[0];
  const setMostrarCopiarHierarquia = mostrarCopiarHierarquiaState[1];

  const confirmacaoState = _s({
    show: false,
    title: '',
    message: '',
    callback: null,
  });
  const confirmacao = confirmacaoState[0];
  const setConfirmacao = confirmacaoState[1];

  const contasAusentesState = _s(null);
  const contasAusentes = contasAusentesState[0];
  const setContasAusentes = contasAusentesState[1];

  // Ordenacao por grid
  const ordGrid1State = _s({ campo: null, direcao: 'asc' });
  const ordGrid1 = ordGrid1State[0];
  const setOrdGrid1 = ordGrid1State[1];
  const ordGrid2State = _s({ campo: null, direcao: 'asc' });
  const ordGrid2 = ordGrid2State[0];
  const setOrdGrid2 = ordGrid2State[1];
  const ordGrid3State = _s({ campo: null, direcao: 'asc' });
  const ordGrid3 = ordGrid3State[0];
  const setOrdGrid3 = ordGrid3State[1];

  // Helpers de ordenacao
  const handleOrdenacao = function(setOrd, campo) {
    return function() {
      setOrd(function(prev) {
        if (prev.campo === campo) {
          return {
            campo: campo,
            direcao: prev.direcao === 'asc' ? 'desc' : 'asc',
          };
        }
        return { campo: campo, direcao: 'asc' };
      });
    };
  };

  const iconeOrdenacao = function(ord, campo) {
    if (ord.campo !== campo)
      return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ord.direcao === 'asc' ? (
      <FaSortUp style={{ marginLeft: 4 }} />
    ) : (
      <FaSortDown style={{ marginLeft: 4 }} />
    );
  };

  const ordenar = function(arr, ord) {
    if (!ord.campo || !arr.length) return arr;
    return arr.slice().sort(function(a, b) {
      const dir = ord.direcao === 'asc' ? 1 : -1;
      const valA = a[ord.campo];
      const valB = b[ord.campo];
      if (valA == null) valA = '';
      if (valB == null) valB = '';
      if (typeof valA === 'number' && typeof valB === 'number')
        return dir * (valA - valB);
      return (
        dir *
        String(valA)
          .toLowerCase()
          .localeCompare(String(valB).toLowerCase())
      );
    });
  };

  const thSortStyle = {
    cursor: 'pointer',
    userSelect: 'none',
    whiteSpace: 'nowrap',
  };

  // Contraste de texto sobre background colorido
  const getTextColor = function(bgHex) {
    if (!bgHex) return undefined;
    const r = parseInt(bgHex.substring(1, 3), 16);
    const g = parseInt(bgHex.substring(3, 5), 16);
    const b = parseInt(bgHex.substring(5, 7), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#212529' : '#ffffff';
  };

  // Carregar GEs na montagem
  useEffect(function() {
    const fetchGEs = async function() {
      try {
        const resp = await api.listarGruposEmpresaHierarquia();
        const opts = (resp || []).map(function(ge) {
          return { value: ge.codigo, label: ge.codigo + ' - ' + ge.apelido };
        });
        setGruposEmpresa(opts);
        if (opts.length === 1) setGeSelecionado(opts[0]);
      } catch (e) {
        toast.error('Erro ao carregar grupos empresa.');
      }
      try {
        const resp2 = await api.listarGruposEmpresaComHierarquia();
        setGesHierarquia(
          (resp2 || []).map(function(ge) {
            return { value: ge.codigo, label: ge.codigo + ' - ' + ge.apelido };
          })
        );
      } catch (e) {
        /* silencioso */
      }
    };
    fetchGEs();
  }, []);

  // Carregar corretores para consulta na montagem
  useEffect(function() {
    const fetchCorretores = async function() {
      try {
        const data = await api.BuscarCorretores();
        setCorretores(
          (data || []).map(function(c) {
            return { value: c.codigo, label: c.codigo + ' - ' + c.descricao };
          })
        );
      } catch (e) {
        /* silencioso */
      }
    };
    fetchCorretores();
  }, []);

  // Quando corretor selecionado muda -> buscar hierarquia
  const handleSelecionarCorretor = function(opcao) {
    setCorretorSelecionado(opcao);
    setOrdConsulta({ campo: null, direcao: 'asc' });
    if (!opcao) {
      setConsultaHierarquia([]);
      return;
    }
    setLoadingConsulta(true);
    const fetchHierarquia = async function() {
      try {
        const data = await api.HierarquiaComercial(opcao.value);
        setConsultaHierarquia(data || []);
      } catch (e) {
        toast.error('Erro ao carregar hierarquia.');
        setConsultaHierarquia([]);
      }
      setLoadingConsulta(false);
    };
    fetchHierarquia();
  };

  const consultaOrdenada = ordenar(consultaHierarquia, ordConsulta);

  // Quando GE muda -> carregar tipos + contas disponiveis
  useEffect(
    function() {
      setTipoSelecionado(null);
      setContasTipo([]);
      setContaSelecionada(null);
      setSubordinados([]);
      setSelectContaTipo(null);
      setSelectContaSub(null);

      if (!geSelecionado) {
        setTiposComissao([]);
        setContasDisponiveis([]);
        return;
      }

      const fetchTipos = async function() {
        setLoading(function(p) {
          return Object.assign({}, p, { tipos: true });
        });
        try {
          const resp = await api.listarTiposComissao();
          setTiposComissao(resp || []);
        } catch (e) {
          toast.error('Erro ao carregar tipos de comissão.');
        }
        setLoading(function(p) {
          return Object.assign({}, p, { tipos: false });
        });
      };

      const fetchContasDisp = async function() {
        try {
          const resp = await api.listarContasDisponiveisHierarquia(
            geSelecionado.value
          );
          setContasDisponiveis(resp || []);
        } catch (e) {
          /* silencioso */
        }
      };

      fetchTipos();
      fetchContasDisp();
    },
    [geSelecionado]
  );

  // Quando tipo muda -> carregar contas do tipo
  useEffect(
    function() {
      setContaSelecionada(null);
      setSubordinados([]);
      setSelectContaSub(null);

      if (!geSelecionado || !tipoSelecionado) {
        setContasTipo([]);
        return;
      }

      const fetchContas = async function() {
        setLoading(function(p) {
          return Object.assign({}, p, { contas: true });
        });
        try {
          const resp = await api.listarContasTipo(
            geSelecionado.value,
            tipoSelecionado.codigo_tipo
          );
          setContasTipo(resp || []);
        } catch (e) {
          toast.error('Erro ao carregar contas do tipo.');
        }
        setLoading(function(p) {
          return Object.assign({}, p, { contas: false });
        });
      };
      fetchContas();
    },
    [geSelecionado, tipoSelecionado]
  );

  // Quando conta muda -> carregar subordinados + contas para subordinacao
  useEffect(
    function() {
      setSubordinados([]);
      setSelectContaSub(null);

      if (!geSelecionado || !tipoSelecionado || !contaSelecionada) {
        setContasSubordinados([]);
        return;
      }

      const fetchSub = async function() {
        setLoading(function(p) {
          return Object.assign({}, p, { subordinados: true });
        });
        try {
          const resp = await api.listarSubordinados(
            geSelecionado.value,
            contaSelecionada.codigo_conta,
            tipoSelecionado.codigo_tipo
          );
          setSubordinados(resp || []);
        } catch (e) {
          toast.error('Erro ao carregar subordinados.');
        }
        setLoading(function(p) {
          return Object.assign({}, p, { subordinados: false });
        });
      };

      const fetchContasSub = async function() {
        try {
          const nivelPai = tipoSelecionado.nivel || 0;
          const resp = await api.listarContasSubordinadosHierarquia(
            geSelecionado.value,
            nivelPai
          );
          setContasSubordinados(resp || []);
        } catch (e) {
          /* silencioso */
        }
      };

      fetchSub();
      fetchContasSub();
    },
    [geSelecionado, tipoSelecionado, contaSelecionada]
  );

  // Acoes CRUD
  const handleIncluirContaTipo = async function() {
    if (!selectContaTipo || !tipoSelecionado || !geSelecionado) {
      toast.warn('Selecione uma conta para incluir.');
      return;
    }
    try {
      await api.incluirContaTipo({
        codigo_grupo_empresa: geSelecionado.value,
        codigo_conta: selectContaTipo.value,
        codigo_tipo: tipoSelecionado.codigo_tipo,
      });
      toast.success('Conta incluída no tipo com sucesso.');
      setSelectContaTipo(null);
      // Recarregar grid 2
      const resp = await api.listarContasTipo(
        geSelecionado.value,
        tipoSelecionado.codigo_tipo
      );
      setContasTipo(resp || []);
    } catch (err) {
      const msg =
        (err && err.response && err.response.data) ||
        (err && err.message) ||
        'Erro ao incluir conta no tipo.';
      toast.error(
        typeof msg === 'string' ? msg : 'Erro ao incluir conta no tipo.'
      );
    }
  };

  const handleExcluirContaTipo = function(item) {
    setConfirmacao({
      show: true,
      title: 'Confirmar Exclusão',
      message:
        'Ao excluir a conta ' +
        item.codigo_conta +
        ' - ' +
        item.apelido_conta +
        ' do tipo, todos os seus subordinados também serão removidos. Deseja continuar?',
      callback: async function(confirmado) {
        setConfirmacao({ show: false, title: '', message: '', callback: null });
        if (!confirmado) return;
        try {
          await api.excluirContaTipo({
            codigo_grupo_empresa: geSelecionado.value,
            codigo_conta: item.codigo_conta,
            codigo_tipo: tipoSelecionado.codigo_tipo,
          });
          toast.success('Conta excluída do tipo com sucesso.');
          setContaSelecionada(null);
          setSubordinados([]);
          const resp = await api.listarContasTipo(
            geSelecionado.value,
            tipoSelecionado.codigo_tipo
          );
          setContasTipo(resp || []);
        } catch (err) {
          const msg =
            (err && err.response && err.response.data) ||
            (err && err.message) ||
            'Erro ao excluir conta do tipo.';
          toast.error(
            typeof msg === 'string' ? msg : 'Erro ao excluir conta do tipo.'
          );
        }
      },
    });
  };

  const handleIncluirSubordinado = async function() {
    if (
      !selectContaSub ||
      !contaSelecionada ||
      !tipoSelecionado ||
      !geSelecionado
    ) {
      toast.warn('Selecione uma conta para incluir como subordinado.');
      return;
    }
    try {
      await api.incluirSubordinado({
        codigo_grupo_empresa: geSelecionado.value,
        codigo_conta: contaSelecionada.codigo_conta,
        tipo_comissao: tipoSelecionado.codigo_tipo,
        codigo_conta_nivel: selectContaSub.value,
        tipo_comissao_nivel: selectContaSub.codigoTipo,
      });
      toast.success('Subordinado incluído com sucesso.');
      setSelectContaSub(null);
      const resp = await api.listarSubordinados(
        geSelecionado.value,
        contaSelecionada.codigo_conta,
        tipoSelecionado.codigo_tipo
      );
      setSubordinados(resp || []);
    } catch (err) {
      const msg =
        (err && err.response && err.response.data) ||
        (err && err.message) ||
        'Erro ao incluir subordinado.';
      toast.error(
        typeof msg === 'string' ? msg : 'Erro ao incluir subordinado.'
      );
    }
  };

  const handleExcluirSubordinado = function(item) {
    setConfirmacao({
      show: true,
      title: 'Confirmar Exclusão',
      message:
        'Deseja excluir o subordinado ' +
        item.codigo_conta_nivel +
        ' - ' +
        item.apelido_conta +
        '?',
      callback: async function(confirmado) {
        setConfirmacao({ show: false, title: '', message: '', callback: null });
        if (!confirmado) return;
        try {
          await api.excluirSubordinado({
            codigo_grupo_empresa: geSelecionado.value,
            codigo_conta: contaSelecionada.codigo_conta,
            tipo_comissao: tipoSelecionado.codigo_tipo,
            codigo_conta_nivel: item.codigo_conta_nivel,
            tipo_comissao_nivel: item.tipo_comissao_nivel,
          });
          toast.success('Subordinado excluído com sucesso.');
          const resp = await api.listarSubordinados(
            geSelecionado.value,
            contaSelecionada.codigo_conta,
            tipoSelecionado.codigo_tipo
          );
          setSubordinados(resp || []);
        } catch (err) {
          const msg =
            (err && err.response && err.response.data) ||
            (err && err.message) ||
            'Erro ao excluir subordinado.';
          toast.error(
            typeof msg === 'string' ? msg : 'Erro ao excluir subordinado.'
          );
        }
      },
    });
  };

  // Copia unitaria
  const handleCopiarUnitaria = async function() {
    if (!geOrigemCopia || !geSelecionado) {
      toast.warn('Selecione um GE de origem para copiar.');
      return;
    }
    setLoading(function(p) {
      return Object.assign({}, p, { copia: true });
    });
    try {
      const validacao = await api.validarCopiaHierarquia({
        ge_origem: geOrigemCopia.value,
        ges_destino: [geSelecionado.value],
      });
      if (!validacao.valido) {
        setContasAusentes(validacao.contas_ausentes);
        setLoading(function(p) {
          return Object.assign({}, p, { copia: false });
        });
        return;
      }
      setLoading(function(p) {
        return Object.assign({}, p, { copia: false });
      });
      setConfirmacao({
        show: true,
        title: 'Cópia Destrutiva',
        message:
          'A cópia irá SUBSTITUIR toda a hierarquia do GE ' +
          geSelecionado.label +
          ' com a do GE ' +
          geOrigemCopia.label +
          '. Esta operação não pode ser desfeita. Continuar?',
        callback: async function(confirmado) {
          setConfirmacao({
            show: false,
            title: '',
            message: '',
            callback: null,
          });
          if (!confirmado) return;
          setLoading(function(p) {
            return Object.assign({}, p, { copia: true });
          });
          try {
            const resp = await api.copiarHierarquia({
              ge_origem: geOrigemCopia.value,
              ge_destino: geSelecionado.value,
            });
            toast.success(
              'Hierarquia copiada: ' +
                resp.tipos_copiados +
                ' tipos, ' +
                resp.niveis_copiados +
                ' níveis.'
            );
            setGeOrigemCopia(null);
            // Recarregar tudo
            const tipos = await api.listarTiposComissao();
            setTiposComissao(tipos || []);
            setTipoSelecionado(null);
            setContasTipo([]);
            setContaSelecionada(null);
            setSubordinados([]);
            // Atualizar GEs com hierarquia
            const gesH = await api.listarGruposEmpresaComHierarquia();
            setGesHierarquia(
              (gesH || []).map(function(ge) {
                return {
                  value: ge.codigo,
                  label: ge.codigo + ' - ' + ge.apelido,
                };
              })
            );
          } catch (err) {
            const msg =
              (err && err.response && err.response.data) ||
              (err && err.message) ||
              'Erro ao copiar hierarquia.';
            toast.error(
              typeof msg === 'string' ? msg : 'Erro ao copiar hierarquia.'
            );
          }
          setLoading(function(p) {
            return Object.assign({}, p, { copia: false });
          });
        },
      });
    } catch (err) {
      const msg =
        (err && err.response && err.response.data) ||
        (err && err.message) ||
        'Erro ao validar cópia.';
      toast.error(typeof msg === 'string' ? msg : 'Erro ao validar cópia.');
      setLoading(function(p) {
        return Object.assign({}, p, { copia: false });
      });
    }
  };

  const handleCopiaMassaConcluida = async function() {
    setMostrarModalCopia(false);
    toast.success('Cópia em massa concluída com sucesso.');
    // Recarregar GEs com hierarquia
    try {
      const gesH = await api.listarGruposEmpresaComHierarquia();
      setGesHierarquia(
        (gesH || []).map(function(ge) {
          return { value: ge.codigo, label: ge.codigo + ' - ' + ge.apelido };
        })
      );
    } catch (e) {
      /* silencioso */
    }
    // Recarregar tipos se GE selecionado
    if (geSelecionado) {
      try {
        const tipos = await api.listarTiposComissao();
        setTiposComissao(tipos || []);
      } catch (e) {
        /* silencioso */
      }
      setTipoSelecionado(null);
      setContasTipo([]);
      setContaSelecionada(null);
      setSubordinados([]);
    }
  };

  // Opcoes para selects
  const optsContaTipo = contasDisponiveis.map(function(c) {
    return {
      value: c.codigo_conta,
      label: c.codigo_conta + ' - ' + c.apelido_conta,
    };
  });

  const optsContaSub = contasSubordinados.map(function(c) {
    return {
      value: c.codigo_conta,
      label:
        c.codigo_conta + ' - ' + c.apelido_conta + ' (' + c.tipo_sigla + ')',
      codigoTipo: c.codigo_tipo,
    };
  });

  const optsGeOrigem = gesHierarquia.filter(function(ge) {
    return !geSelecionado || ge.value !== geSelecionado.value;
  });

  // Dados ordenados
  const tiposOrdenados = ordenar(tiposComissao, ordGrid1);
  const contasOrdenadas = ordenar(contasTipo, ordGrid2);
  const subordinadosOrdenados = ordenar(subordinados, ordGrid3);

  // Cor do tipo selecionado
  const corTipoSelecionado = tipoSelecionado
    ? intToHexColor(tipoSelecionado.cor)
    : undefined;

  // Helper: Loading indicator
  const renderLoading = function(text) {
    return (
      <div className="hc-loading">
        <div className="hc-spinner"></div>
        <span className="hc-loading-text">{text || 'Carregando...'}</span>
      </div>
    );
  };

  // Helper: Empty state
  const renderEmpty = function(icon, text) {
    return (
      <div className="hc-empty-state">
        <div className="hc-empty-state-icon">{icon}</div>
        <span className="hc-empty-state-text">{text}</span>
      </div>
    );
  };

  // Helper: Card header
  const renderCardHeader = function(icon, title, count, bgColor, textColor) {
    return (
      <div
        className="hc-card-header"
        style={{
          backgroundColor: bgColor || '#0747a6',
          color: textColor || '#fff',
        }}
      >
        <span className="hc-card-header-title">
          {icon}
          {title}
        </span>
        {count !== undefined && <span className="hc-badge-count">{count}</span>}
      </div>
    );
  };

  return (
    <Container fluid className="px-3 py-3">
      <Header title="Hierarquia Comercial" />

      {/* Card container com abas */}
      <Card className="shadow-sm mb-3 hc-tab-card">
        <Card.Header className="hc-tab-card-header p-0">
          <Nav
            className="hc-tabs"
            activeKey={abaAtiva}
            onSelect={setAbaAtiva}
          >
            <Nav.Item>
              <Nav.Link eventKey="gestao">
                <FaSitemap className="mr-1" /> Gestão
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="consulta">
                <FaSearch className="mr-1" /> Consulta por Conta
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Card.Header>
        <Card.Body className="hc-tab-card-body">

      {/* === ABA CONSULTA === */}
      {abaAtiva === 'consulta' && (
        <>
          <Row className="align-items-center mb-3">
            <Col md={5}>
              <Select
                placeholder="Selecione um corretor / prestador..."
                options={corretores}
                value={corretorSelecionado}
                onChange={handleSelecionarCorretor}
                isClearable
                components={{ DropdownIndicator }}
                styles={customStyles}
              />
            </Col>
          </Row>

          {corretorSelecionado && (
            <Card className="mb-3 hc-grid-card">
              {renderCardHeader(
                <FaUsers />,
                'Hierarquia de: ' + corretorSelecionado.label,
                consultaHierarquia.length
              )}
              <Card.Body className="p-0">
                {loadingConsulta ? (
                  renderLoading('Buscando hierarquia...')
                ) : consultaOrdenada.length === 0 ? (
                  renderEmpty(
                    <FaSitemap />,
                    'Corretor sem hierarquia cadastrada.'
                  )
                ) : (
                  <>
                    {/* Desktop */}
                    <div className="hc-desktop">
                      <Table striped bordered hover size="sm" className="mb-0">
                        <thead>
                          <tr>
                            <th
                              style={thSortStyle}
                              onClick={handleOrdenacao(
                                setOrdConsulta,
                                'supervisor_conta'
                              )}
                            >
                              Supervisor (Conta)
                              {iconeOrdenacao(ordConsulta, 'supervisor_conta')}
                            </th>
                            <th
                              style={thSortStyle}
                              onClick={handleOrdenacao(
                                setOrdConsulta,
                                'supervisor_ge'
                              )}
                            >
                              Supervisor (GE)
                              {iconeOrdenacao(ordConsulta, 'supervisor_ge')}
                            </th>
                            <th
                              style={thSortStyle}
                              onClick={handleOrdenacao(
                                setOrdConsulta,
                                'supervisor'
                              )}
                            >
                              Supervisor (Nome)
                              {iconeOrdenacao(ordConsulta, 'supervisor')}
                            </th>
                            <th
                              style={thSortStyle}
                              onClick={handleOrdenacao(
                                setOrdConsulta,
                                'corretor_conta'
                              )}
                            >
                              Corretor (Conta)
                              {iconeOrdenacao(ordConsulta, 'corretor_conta')}
                            </th>
                            <th
                              style={thSortStyle}
                              onClick={handleOrdenacao(
                                setOrdConsulta,
                                'corretor_ge'
                              )}
                            >
                              Corretor (GE)
                              {iconeOrdenacao(ordConsulta, 'corretor_ge')}
                            </th>
                            <th
                              style={thSortStyle}
                              onClick={handleOrdenacao(
                                setOrdConsulta,
                                'corretor'
                              )}
                            >
                              Corretor (Nome)
                              {iconeOrdenacao(ordConsulta, 'corretor')}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {consultaOrdenada.map(function(item, index) {
                            return (
                              <tr key={index}>
                                <td>{item.supervisor_conta}</td>
                                <td>{item.supervisor_ge}</td>
                                <td>{item.supervisor}</td>
                                <td>{item.corretor_conta}</td>
                                <td>{item.corretor_ge}</td>
                                <td>{item.corretor}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>

                    {/* Mobile */}
                    <div className="hc-mobile p-2">
                      {consultaOrdenada.map(function(item, index) {
                        return (
                          <Card key={index} className="mb-2 shadow-sm">
                            <Card.Body className="py-2 px-3">
                              <div className="mb-2">
                                <strong style={{ color: '#0747a6' }}>
                                  Supervisor
                                </strong>
                                <br />
                                <small>
                                  Conta: {item.supervisor_conta} | GE:{' '}
                                  {item.supervisor_ge}
                                </small>
                                <br />
                                <span>{item.supervisor}</span>
                              </div>
                              <hr className="my-1" />
                              <div>
                                <strong style={{ color: '#0747a6' }}>
                                  Corretor
                                </strong>
                                <br />
                                <small>
                                  Conta: {item.corretor_conta} | GE:{' '}
                                  {item.corretor_ge}
                                </small>
                                <br />
                                <span>{item.corretor}</span>
                              </div>
                            </Card.Body>
                          </Card>
                        );
                      })}
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
          )}
        </>
      )}

      {/* === ABA GESTAO === */}
      {abaAtiva === 'gestao' && (
        <>
          {/* Filtro GE */}
          <Row className="align-items-center mb-3">
            <Col md={4}>
              <Select
                placeholder="Selecione o Grupo Empresa..."
                options={gruposEmpresa}
                value={geSelecionado}
                onChange={setGeSelecionado}
                isClearable
                components={{ DropdownIndicator }}
                styles={customStyles}
              />
            </Col>
            {geSelecionado && (
              <Col xs="auto">
                <Button
                  variant="outline-primary"
                  style={{ fontSize: '0.875rem', padding: '6px 12px' }}
                  onClick={function() {
                    setMostrarCopiarHierarquia(true);
                  }}
                >
                  <FaExchangeAlt className="mr-1" /> Copiar Hierarquia
                </Button>
              </Col>
            )}
          </Row>

          {/* Flow breadcrumb */}
          {geSelecionado && (
            <div className="hc-flow mb-2">
              <span className="hc-flow-step active">{geSelecionado.label}</span>
              <FaChevronRight className="hc-flow-arrow" />
              <span
                className={'hc-flow-step' + (tipoSelecionado ? ' active' : '')}
                style={
                  tipoSelecionado && corTipoSelecionado
                    ? {
                        backgroundColor: corTipoSelecionado,
                        color: getTextColor(corTipoSelecionado),
                      }
                    : undefined
                }
              >
                {tipoSelecionado ? tipoSelecionado.descricao : 'Tipo'}
              </span>
              <FaChevronRight className="hc-flow-arrow" />
              <span
                className={'hc-flow-step' + (contaSelecionada ? ' active' : '')}
              >
                {contaSelecionada
                  ? contaSelecionada.codigo_conta +
                    ' - ' +
                    contaSelecionada.apelido_conta
                  : 'Conta'}
              </span>
            </div>
          )}

          {/* Pills Tipo Comissão + 2 Grids — Desktop */}
          {geSelecionado && (
            <div className="hc-desktop">
              <Row>
                {/* Col 1 — Pills Tipo Comissão (vertical) */}
                <Col md={3}>
                  <div className="hc-pills-section mb-3">
                    <div
                      className="d-flex align-items-center mb-2"
                      style={{ gap: '8px' }}
                    >
                      <FaLayerGroup
                        style={{ color: '#0747a6', fontSize: '0.9rem' }}
                      />
                      <span
                        style={{
                          fontSize: '0.85rem',
                          fontWeight: 600,
                          color: '#495057',
                        }}
                      >
                        Tipo Comissão
                      </span>
                      <span
                        className="hc-badge-count"
                        style={{ backgroundColor: '#e9ecef', color: '#495057' }}
                      >
                        {tiposComissao.length}
                      </span>
                    </div>
                    {loading.tipos ? (
                      renderLoading('Carregando tipos...')
                    ) : tiposOrdenados.length === 0 ? (
                      renderEmpty(<FaLayerGroup />, 'Nenhum tipo de comissão.')
                    ) : (
                      <div className="hc-pills-bar hc-pills-vertical">
                        {tiposOrdenados.map(function(tipo) {
                          const bg = intToHexColor(tipo.cor);
                          const isSelected =
                            tipoSelecionado &&
                            tipoSelecionado.codigo_tipo === tipo.codigo_tipo;
                          return (
                            <button
                              key={tipo.codigo_tipo}
                              type="button"
                              className={
                                'hc-pill' +
                                (isSelected ? ' hc-pill-active' : '')
                              }
                              style={{
                                backgroundColor: bg || '#e9ecef',
                                color: bg ? getTextColor(bg) : '#495057',
                              }}
                              title={
                                'Nível ' +
                                tipo.nivel +
                                ' — Código ' +
                                tipo.codigo_tipo +
                                ' — ' +
                                tipo.descricao
                              }
                              onClick={function() {
                                setTipoSelecionado(tipo);
                              }}
                            >
                              <span className="hc-pill-id">
                                {'#' + tipo.codigo_tipo}
                              </span>
                              <span className="hc-pill-nivel">
                                {'Nív. ' + tipo.nivel}
                              </span>
                              {tipo.descricao}
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </Col>

                {/* Grid 2 — Contas do Tipo */}
                <Col md={5}>
                  <Card className="mb-3 hc-grid-card">
                    {renderCardHeader(
                      <FaUsers />,
                      tipoSelecionado
                        ? 'Pertencentes: ' + tipoSelecionado.descricao
                        : 'Pertencentes ao Tipo',
                      contasTipo.length,
                      corTipoSelecionado || '#0747a6',
                      corTipoSelecionado
                        ? getTextColor(corTipoSelecionado)
                        : '#fff'
                    )}
                    {tipoSelecionado && (
                      <div className="hc-action-row">
                        <div className="hc-select-wrapper">
                          <Select
                            placeholder="Selecione uma conta..."
                            options={optsContaTipo}
                            value={selectContaTipo}
                            onChange={setSelectContaTipo}
                            isClearable
                            components={{ DropdownIndicator }}
                            styles={customStyles}
                            menuPortalTarget={document.body}
                          />
                        </div>
                        <Button
                          size="sm"
                          variant="primary"
                          onClick={handleIncluirContaTipo}
                        >
                          <FaPlus className="mr-1" /> Incluir
                        </Button>
                      </div>
                    )}
                    <Card.Body className="p-0">
                      {loading.contas ? (
                        renderLoading('Carregando contas...')
                      ) : !tipoSelecionado ? (
                        renderEmpty(
                          <FaChevronRight />,
                          'Selecione um tipo de comissão ao lado.'
                        )
                      ) : contasOrdenadas.length === 0 ? (
                        renderEmpty(
                          <FaUsers />,
                          'Nenhuma conta vinculada a este tipo.'
                        )
                      ) : (
                        <div className="hc-grid-scroll">
                          <Table bordered hover size="sm" className="hc-table">
                            <thead>
                              <tr>
                                <th
                                  style={Object.assign(
                                    { width: '70px' },
                                    thSortStyle
                                  )}
                                  onClick={handleOrdenacao(
                                    setOrdGrid2,
                                    'codigo_conta'
                                  )}
                                >
                                  Código
                                  {iconeOrdenacao(ordGrid2, 'codigo_conta')}
                                </th>
                                <th
                                  style={thSortStyle}
                                  onClick={handleOrdenacao(
                                    setOrdGrid2,
                                    'apelido_conta'
                                  )}
                                >
                                  Nome
                                  {iconeOrdenacao(ordGrid2, 'apelido_conta')}
                                </th>
                                <th
                                  style={{ width: '45px', textAlign: 'center' }}
                                ></th>
                              </tr>
                            </thead>
                            <tbody>
                              {contasOrdenadas.map(function(item) {
                                const bg = corTipoSelecionado;
                                const isSelected =
                                  contaSelecionada &&
                                  contaSelecionada.codigo_conta ===
                                    item.codigo_conta;
                                return (
                                  <tr
                                    key={item.codigo_conta}
                                    onClick={function() {
                                      setContaSelecionada(item);
                                    }}
                                    className={
                                      'hc-row-clickable' +
                                      (isSelected ? ' hc-row-selected' : '')
                                    }
                                    style={{
                                      backgroundColor: bg || undefined,
                                      color: bg ? getTextColor(bg) : undefined,
                                    }}
                                  >
                                    <td>{item.codigo_conta}</td>
                                    <td>{item.apelido_conta}</td>
                                    <td className="text-center">
                                      <Button
                                        size="sm"
                                        variant="link"
                                        className="p-0 hc-action-btn"
                                        style={{
                                          color: bg
                                            ? getTextColor(bg)
                                            : '#dc3545',
                                        }}
                                        onClick={function(e) {
                                          e.stopPropagation();
                                          handleExcluirContaTipo(item);
                                        }}
                                        title="Excluir conta do tipo"
                                      >
                                        <FaTrash />
                                      </Button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </Col>

                {/* Grid 3 — Subordinados */}
                <Col md={4}>
                  <Card className="mb-3 hc-grid-card">
                    {renderCardHeader(
                      <FaUserFriends />,
                      contaSelecionada
                        ? 'Abaixo de: ' + contaSelecionada.apelido_conta
                        : 'Abaixo do Selecionado',
                      subordinados.length
                    )}
                    {contaSelecionada && (
                      <div className="hc-action-row">
                        <div className="hc-select-wrapper">
                          <Select
                            placeholder="Selecione um subordinado..."
                            options={optsContaSub}
                            value={selectContaSub}
                            onChange={setSelectContaSub}
                            isClearable
                            components={{ DropdownIndicator }}
                            styles={customStyles}
                            menuPortalTarget={document.body}
                          />
                        </div>
                        <Button
                          size="sm"
                          variant="primary"
                          onClick={handleIncluirSubordinado}
                        >
                          <FaPlus className="mr-1" /> Incluir
                        </Button>
                      </div>
                    )}
                    <Card.Body className="p-0">
                      {loading.subordinados ? (
                        renderLoading('Carregando subordinados...')
                      ) : !contaSelecionada ? (
                        renderEmpty(
                          <FaChevronRight />,
                          'Selecione uma conta no grid ao lado.'
                        )
                      ) : subordinadosOrdenados.length === 0 ? (
                        renderEmpty(<FaUserFriends />, 'Nenhum subordinado.')
                      ) : (
                        <div className="hc-grid-scroll">
                          <Table bordered hover size="sm" className="hc-table">
                            <thead>
                              <tr>
                                <th
                                  style={Object.assign(
                                    { width: '70px' },
                                    thSortStyle
                                  )}
                                  onClick={handleOrdenacao(
                                    setOrdGrid3,
                                    'codigo_conta_nivel'
                                  )}
                                >
                                  Código
                                  {iconeOrdenacao(
                                    ordGrid3,
                                    'codigo_conta_nivel'
                                  )}
                                </th>
                                <th
                                  style={thSortStyle}
                                  onClick={handleOrdenacao(
                                    setOrdGrid3,
                                    'apelido_conta'
                                  )}
                                >
                                  Nome
                                  {iconeOrdenacao(ordGrid3, 'apelido_conta')}
                                </th>
                                <th
                                  style={Object.assign(
                                    { width: '50px' },
                                    thSortStyle
                                  )}
                                  onClick={handleOrdenacao(
                                    setOrdGrid3,
                                    'tipo_sigla'
                                  )}
                                >
                                  Tipo{iconeOrdenacao(ordGrid3, 'tipo_sigla')}
                                </th>
                                <th
                                  style={{ width: '45px', textAlign: 'center' }}
                                ></th>
                              </tr>
                            </thead>
                            <tbody>
                              {subordinadosOrdenados.map(function(item, idx) {
                                const bg = intToHexColor(item.cor);
                                return (
                                  <tr
                                    key={idx}
                                    style={{
                                      backgroundColor: bg || undefined,
                                      color: bg ? getTextColor(bg) : undefined,
                                    }}
                                  >
                                    <td>{item.codigo_conta_nivel}</td>
                                    <td>{item.apelido_conta}</td>
                                    <td>{item.tipo_sigla}</td>
                                    <td className="text-center">
                                      <Button
                                        size="sm"
                                        variant="link"
                                        className="p-0 hc-action-btn"
                                        style={{
                                          color: bg
                                            ? getTextColor(bg)
                                            : '#dc3545',
                                        }}
                                        onClick={function() {
                                          handleExcluirSubordinado(item);
                                        }}
                                        title="Excluir subordinado"
                                      >
                                        <FaTrash />
                                      </Button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          )}

          {/* Pills + 2 Grids empilhados — Mobile */}
          {geSelecionado && (
            <div className="hc-mobile">
              {/* Pills — Tipo Comissão (scroll horizontal) */}
              <div className="hc-pills-section mb-3">
                <div
                  className="d-flex align-items-center mb-2"
                  style={{ gap: '8px' }}
                >
                  <FaLayerGroup
                    style={{ color: '#0747a6', fontSize: '0.9rem' }}
                  />
                  <span
                    style={{
                      fontSize: '0.85rem',
                      fontWeight: 600,
                      color: '#495057',
                    }}
                  >
                    Tipo Comissão
                  </span>
                </div>
                {loading.tipos ? (
                  renderLoading('Carregando tipos...')
                ) : tiposOrdenados.length === 0 ? (
                  renderEmpty(<FaLayerGroup />, 'Nenhum tipo de comissão.')
                ) : (
                  <div className="hc-pills-scroll-wrapper">
                    <div className="hc-pills-bar">
                      {tiposOrdenados.map(function(tipo) {
                        const bg = intToHexColor(tipo.cor);
                        const isSelected =
                          tipoSelecionado &&
                          tipoSelecionado.codigo_tipo === tipo.codigo_tipo;
                        return (
                          <button
                            key={tipo.codigo_tipo}
                            type="button"
                            className={
                              'hc-pill' + (isSelected ? ' hc-pill-active' : '')
                            }
                            style={{
                              backgroundColor: bg || '#e9ecef',
                              color: bg ? getTextColor(bg) : '#495057',
                            }}
                            title={
                              'Nível ' +
                              tipo.nivel +
                              ' — Código ' +
                              tipo.codigo_tipo +
                              ' — ' +
                              tipo.descricao
                            }
                            onClick={function() {
                              setTipoSelecionado(tipo);
                            }}
                          >
                            <span className="hc-pill-id">
                              {'#' + tipo.codigo_tipo}
                            </span>
                            <span className="hc-pill-nivel">
                              {'Nív. ' + tipo.nivel}
                            </span>
                            {tipo.descricao}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              {/* Grid 2 Mobile */}
              {tipoSelecionado && (
                <Card className="mb-3 hc-grid-card">
                  {renderCardHeader(
                    <FaUsers />,
                    'Pertencentes: ' + tipoSelecionado.descricao,
                    contasTipo.length,
                    corTipoSelecionado || '#0747a6',
                    corTipoSelecionado
                      ? getTextColor(corTipoSelecionado)
                      : '#fff'
                  )}
                  <div className="hc-action-row">
                    <div className="hc-select-wrapper">
                      <Select
                        placeholder="Conta..."
                        options={optsContaTipo}
                        value={selectContaTipo}
                        onChange={setSelectContaTipo}
                        isClearable
                        components={{ DropdownIndicator }}
                        styles={customStyles}
                      />
                    </div>
                    <Button
                      size="sm"
                      variant="primary"
                      onClick={handleIncluirContaTipo}
                    >
                      <FaPlus />
                    </Button>
                  </div>
                  <Card.Body className="p-0">
                    {contasOrdenadas.map(function(item) {
                      const isSelected =
                        contaSelecionada &&
                        contaSelecionada.codigo_conta === item.codigo_conta;
                      return (
                        <div
                          key={item.codigo_conta}
                          className={
                            'hc-mobile-item' +
                            (isSelected ? ' hc-mobile-selected' : '')
                          }
                          onClick={function() {
                            setContaSelecionada(item);
                          }}
                        >
                          <span className="hc-mobile-item-content">
                            <strong>{item.codigo_conta}</strong> —{' '}
                            {item.apelido_conta}
                          </span>
                          <Button
                            size="sm"
                            variant="link"
                            className="p-0 hc-action-btn"
                            style={{ color: '#dc3545' }}
                            onClick={function(e) {
                              e.stopPropagation();
                              handleExcluirContaTipo(item);
                            }}
                          >
                            <FaTrash />
                          </Button>
                        </div>
                      );
                    })}
                    {contasOrdenadas.length === 0 &&
                      renderEmpty(<FaUsers />, 'Nenhuma conta vinculada.')}
                  </Card.Body>
                </Card>
              )}

              {/* Grid 3 Mobile */}
              {contaSelecionada && (
                <Card className="mb-3 hc-grid-card">
                  {renderCardHeader(
                    <FaUserFriends />,
                    'Abaixo de: ' + contaSelecionada.apelido_conta,
                    subordinados.length
                  )}
                  <div className="hc-action-row">
                    <div className="hc-select-wrapper">
                      <Select
                        placeholder="Subordinado..."
                        options={optsContaSub}
                        value={selectContaSub}
                        onChange={setSelectContaSub}
                        isClearable
                        components={{ DropdownIndicator }}
                        styles={customStyles}
                      />
                    </div>
                    <Button
                      size="sm"
                      variant="primary"
                      onClick={handleIncluirSubordinado}
                    >
                      <FaPlus />
                    </Button>
                  </div>
                  <Card.Body className="p-0">
                    {subordinadosOrdenados.map(function(item, idx) {
                      const bg = intToHexColor(item.cor);
                      return (
                        <div
                          key={idx}
                          className="hc-mobile-item"
                          style={{
                            backgroundColor: bg || undefined,
                            color: bg ? getTextColor(bg) : undefined,
                          }}
                        >
                          <span className="hc-mobile-item-content">
                            <strong>{item.codigo_conta_nivel}</strong> —{' '}
                            {item.apelido_conta} ({item.tipo_sigla})
                          </span>
                          <Button
                            size="sm"
                            variant="link"
                            className="p-0 hc-action-btn"
                            style={{ color: bg ? getTextColor(bg) : '#dc3545' }}
                            onClick={function() {
                              handleExcluirSubordinado(item);
                            }}
                          >
                            <FaTrash />
                          </Button>
                        </div>
                      );
                    })}
                    {subordinadosOrdenados.length === 0 &&
                      renderEmpty(<FaUserFriends />, 'Nenhum subordinado.')}
                  </Card.Body>
                </Card>
              )}
            </div>
          )}

          {/* Modal Copiar Hierarquia */}
          {mostrarCopiarHierarquia && geSelecionado && (
            <div
              className="hc-ausentes-overlay"
              onClick={function() {
                setMostrarCopiarHierarquia(false);
              }}
            >
              <div
                className="hc-copy-dialog"
                onClick={function(e) {
                  e.stopPropagation();
                }}
              >
                <div className="hc-copy-dialog-header">
                  <strong>
                    <FaExchangeAlt className="mr-2" />
                    Copiar Hierarquia
                  </strong>
                  <button
                    type="button"
                    className="close"
                    style={{ color: '#fff', opacity: 0.9 }}
                    onClick={function() {
                      setMostrarCopiarHierarquia(false);
                    }}
                  >
                    <span>&times;</span>
                  </button>
                </div>
                <div className="hc-copy-dialog-body">
                  <p style={{ fontSize: '0.85rem', color: '#6c757d', marginBottom: '14px' }}>
                    Copiar a hierarquia de outro GE para <strong>{geSelecionado.label}</strong>.
                    Esta operação substitui toda a hierarquia existente.
                  </p>
                  <div className="hc-copy-field mb-3">
                    <label>Copiar do GE:</label>
                    <Select
                      placeholder="Selecione o GE de origem..."
                      options={optsGeOrigem}
                      value={geOrigemCopia}
                      onChange={setGeOrigemCopia}
                      isClearable
                      components={{ DropdownIndicator }}
                      styles={customStyles}
                      menuPortalTarget={document.body}
                    />
                  </div>
                  <div className="d-flex align-items-center" style={{ gap: '10px', flexWrap: 'wrap' }}>
                    <Button
                      size="sm"
                      variant="primary"
                      onClick={handleCopiarUnitaria}
                      disabled={loading.copia || !geOrigemCopia}
                    >
                      {loading.copia ? 'Copiando...' : 'Copiar para este GE'}
                    </Button>
                    <div className="hc-copy-divider"></div>
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      onClick={function() {
                        setMostrarCopiarHierarquia(false);
                        setMostrarModalCopia(true);
                      }}
                    >
                      <FaCopy className="mr-1" /> Cópia em Massa
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal contas ausentes */}
          {contasAusentes && contasAusentes.length > 0 && (
            <div
              className="hc-ausentes-overlay"
              onClick={function() {
                setContasAusentes(null);
              }}
            >
              <div
                className="hc-ausentes-dialog"
                onClick={function(e) {
                  e.stopPropagation();
                }}
              >
                <div className="hc-ausentes-header">
                  <strong>Contas Ausentes no GE Destino</strong>
                  <button
                    type="button"
                    className="close"
                    style={{ color: '#fff', opacity: 0.9 }}
                    onClick={function() {
                      setContasAusentes(null);
                    }}
                  >
                    <span>&times;</span>
                  </button>
                </div>
                <div className="hc-ausentes-body">
                  <p
                    style={{
                      fontSize: '0.85rem',
                      color: '#6c757d',
                      marginBottom: '12px',
                    }}
                  >
                    As contas abaixo não existem no GE destino. Cadastre-as
                    antes de copiar:
                  </p>
                  <Table bordered size="sm" className="hc-table">
                    <thead>
                      <tr>
                        <th>Código</th>
                        <th>Nome</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contasAusentes.map(function(c, i) {
                        return (
                          <tr key={i}>
                            <td>{c.codigo_conta}</td>
                            <td>{c.apelido_conta}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <div
                  style={{
                    padding: '10px 18px',
                    borderTop: '1px solid #eee',
                    textAlign: 'right',
                  }}
                >
                  <Button
                    size="sm"
                    variant="secondary"
                    onClick={function() {
                      setContasAusentes(null);
                    }}
                  >
                    Fechar
                  </Button>
                </div>
              </div>
            </div>
          )}
        </>
      )}

        </Card.Body>
      </Card>

      {/* ModalConfirmacao generico */}
      <ModalConfirmacao
        show={confirmacao.show}
        title={confirmacao.title}
        message={confirmacao.message}
        onClose={
          confirmacao.callback ||
          function() {
            setConfirmacao({
              show: false,
              title: '',
              message: '',
              callback: null,
            });
          }
        }
      />

      {/* Modal Copiar em Massa */}
      <ModalCopiarHierarquia
        mostrar={mostrarModalCopia}
        onFechar={function() {
          setMostrarModalCopia(false);
        }}
        onConcluido={handleCopiaMassaConcluida}
        gesHierarquia={gesHierarquia}
      />
    </Container>
  );
};

export default HierarquiaComercial;
